import { render, staticRenderFns } from "./newQRCode.vue?vue&type=template&id=5aa4a9fe&scoped=true&"
import script from "./newQRCode.vue?vue&type=script&lang=js&"
export * from "./newQRCode.vue?vue&type=script&lang=js&"
import style0 from "./newQRCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4a9fe",
  null
  
)

component.options.__file = "newQRCode.vue"
export default component.exports